module.exports = __webpack_public_path__ + "img/styria-print-group.49ecfbca.svg";